import React from "react";
import {
  formatFechaHoraCierre,
  formatNumeroCierre,
} from "./ajusteMensualesFormatters";
import "./AjusteMensuales.css";

/**
 * Columnas alineadas al diseño de referencia: Cierre de turno (19 columnas).
 */
const AjusteMensualesConsultaTurnoTable = ({ cierres }) => {
  if (!Array.isArray(cierres) || cierres.length === 0) {
    return null;
  }

  return (
    <div className="ajuste-mensuales-scroll">
      <table className="ajuste-mensuales-data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>COD_TERMINAL</th>
            <th>COD_PARK</th>
            <th>COD_EMPLEADO</th>
            <th>FECHA_FINAL</th>
            <th>FACTURA_INI</th>
            <th>FACTURA_FIN</th>
            <th>TOTAL</th>
            <th>SUBTOTAL</th>
            <th>REPORTADO</th>
            <th>TOTAL_EFECTIVO</th>
            <th>TOTAL_TC</th>
            <th>TOTAL_MENSUALES_EF</th>
            <th>TOTAL_MENSUALES_TC</th>
            <th>IVA_EFECTIVO</th>
            <th>IVA_DATAFONO</th>
            <th>NOTAS_CREDITO</th>
            <th>ESTADO</th>
            <th>ID_INICIO_TURNO</th>
            <th>ID_INICIO_DIA</th>
          </tr>
        </thead>
        <tbody>
          {cierres.map((r) => (
            <tr key={r.id}>
              <td>{r.id ?? ""}</td>
              <td>{r.codTerminal ?? ""}</td>
              <td>{r.codPark ?? ""}</td>
              <td>{r.codEmpleado ?? ""}</td>
              <td>{formatFechaHoraCierre(r.fechaFinal)}</td>
              <td>{r.facturaIni ?? ""}</td>
              <td>{r.facturaFin ?? ""}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.total)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.subtotal)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.reportado)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalEfectivo)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalTc)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalMensualesEf)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalMensualesTc)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.ivaEfectivo)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.ivaDatafono)}</td>
              <td className="ajuste-mensuales-num">{formatNumeroCierre(r.notasCredito)}</td>
              <td>{r.estado ?? ""}</td>
              <td>{r.idInicioTurno ?? ""}</td>
              <td>{r.idInicioDia ?? ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AjusteMensualesConsultaTurnoTable;
